import { render } from "./htmlTextBlock.vue?vue&type=template&id=bf351fa4&ts=true"
import script from "./htmlTextBlock.vue?vue&type=script&lang=ts"
export * from "./htmlTextBlock.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__